import axios from "axios";
import AuthenticationContext from "adal-angular/lib/adal.js";
import $ from "jquery";
const config = {
  tenant: `${process.env.VUE_APP_ADAL_TENANT}`,
  clientId: `${process.env.VUE_APP_ADAL_CLIENT_ID}`,
  redirectUri: `${process.env.VUE_APP_AUTH_URL}`,
  cacheLocation: `${process.env.VUE_APP_AUTH_URL}`
};
export default {
  authenticationContext: null,
  userProfilePromise: null,
  /**
   * @return {Promise}
   */
  initialize() {
    if (
      process.env.VUE_APP_BYPASS_AD_LOGIN == "true" &&
      process.env.NODE_ENV === "development"
    )
      return Promise.resolve();
    this.authenticationContext = new AuthenticationContext(config);
    return new Promise((resolve, reject) => {
      if (
        this.authenticationContext.isCallback(window.location.hash) ||
        window !== window.parent
      ) {
        // redirect to the location specified in the url params.
        this.authenticationContext.handleWindowCallback();
      } else {
        var user = this.authenticationContext.getCachedUser();

        if (user && window.parent === window && !window.opener) {
        } else {
          // Set window to own parent so href to site page with 'target="_blank"' doesn't get stuck in a signin loop
          // Adding 'rel="noopener"' to <a> tag will bypass needing to sign in if there is a user
          window.parent = window;
          window.opener = null;
          // no user, kick off the sign in flow.
          this.signIn();
        }
        resolve();
      }
    });
  },
  /**
   * @return {String} Silently acquire new token
   */
  acquireToken() {
    this.getUser();
    this.authenticationContext.acquireToken(config.clientId, (error, token) => {
      if (error || !token) console.log(error); // this.acquireTokenRedirect();
    });
    return this.getCachedToken();
  },
  // If no valid token services will call and await this to try to get a new token
  acquireTokenAsync() {
    this.getUser();
    return new Promise((resolve, reject) => {
      this.authenticationContext.acquireToken(
        config.clientId,
        (error, token) => {
          if (error || !token) console.log(error);
          return resolve();
        }
      );
    }).catch(e => {
      console.log(e);
      return Promise.resolve(false);
    });
  },
  /**
   * Issue an interactive authentication request for the current user and the api resource.
   */
  acquireTokenRedirect() {
    this.authenticationContext.acquireTokenRedirect(config.clientId);
  },
  /**
   * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
   * If there is no token try to acquire it then check again
   */
  async isAuthenticated() {
    await this.checkIndexHtml();
    var token = this.getCachedToken();
    if (token) return Promise.resolve(true);
    await this.acquireTokenAsync();
    token = this.getCachedToken();
    if (token) return Promise.resolve(true);
    return Promise.resolve(false);
  },
  getToken() {
    var token = this.getCachedToken();
    if (token) return token;
    token = this.acquireToken();
    return token;
  },
  // getCachedToken will only return a valid, non-expired token.
  getCachedToken() {
    if (
      process.env.VUE_APP_BYPASS_AD_LOGIN == "true" &&
      process.env.NODE_ENV === "development"
    )
      return "--Token--";
    else return this.authenticationContext.getCachedToken(config.clientId);
  },
  /**
   * @return {Promise.<Object>} An ADAL user profile object.
   */
  getUserProfile() {
    if (!this.userProfilePromise) {
      this.userProfilePromise = this.initialize().then(() => {
        return this.authenticationContext.getCachedUser().profile;
      });
    }
    return this.userProfilePromise;
  },
  getUser() {
    try {
      return this.authenticationContext.getCachedUser();
    } catch (e) {
      return { profile: { given_name: "ParcelShield User" } };
    }
  },
  signIn() {
    this.authenticationContext.login().then();
  },
  signOut() {
    if (this.authenticationContext) this.authenticationContext.logOut();
  },
  checkIndexHtml() {
    if (process.env.NODE_ENV === "development") return Promise.resolve();
    return axios.get(process.env.VUE_APP_AUTH_URL).then(x => {
      var buildDate = document
        .querySelector("meta[property='builddate']")
        .getAttribute("content");
      var sourceBuildDate = $.parseHTML(x.data).find(
        x => x.name === "builddate"
      );
      if (sourceBuildDate)
        if (sourceBuildDate.content !== buildDate) location.reload();
    });
  }
};
